var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FirestoreService } from 'common-lib';
import { OnInit, EventEmitter } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Subscription } from 'rxjs';
import { Story } from '../models';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserService } from '../user.service';
export class HeaderComponent {
    constructor(fire, auth, route, router, users) {
        this.fire = fire;
        this.auth = auth;
        this.route = route;
        this.router = router;
        this.users = users;
        this.showHome = false;
        this.showFind = true;
        this.showMenu = true;
        this.showBack = false;
        this.backUrl = null;
        this.showFav = false;
        this.hasFav = false;
        this.clickFav = new EventEmitter();
        this.clickBack = new EventEmitter();
        this.anonymous = true;
        this.showInvalidProfileModal = false;
        this.isCheckProfile = true;
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.showMenu = event.url !== '/menu';
                // プロフィール画面ではプロフィール入力済みチェックを行わないためここでURLをチェック
                this.isCheckProfile = !/^\/profile/.test(event.url);
            }
        });
    }
    ngOnInit() {
        this.userSub = this.auth.user.subscribe((user) => __awaiter(this, void 0, void 0, function* () {
            this.user = user;
            if (user) {
                this.anonymous = user.isAnonymous;
                this.profile = yield this.users.getProfile();
                if (this.profile) {
                    yield this.checkProfile();
                    // プロフィール登録済みなら各情報をKARTEに送信
                    // KARTEタグ: 個人情報
                    tracker.user({
                        user_id: user.uid,
                        email: user.email,
                        name: this.profile.name,
                        subscription: this.profile.optIn,
                        company_name: this.profile.companyName,
                    });
                    // KARTEタグ: ユーザー情報
                    tracker.track('attribute', {
                        educational_background: this.profile.educationalBackground,
                        company_post: this.profile.companyPost,
                        parent_job_type: this.profile.jobType,
                        annual_income_string: this.profile.annualIncome,
                        signup_date: this.user.metadata.creationTime,
                        company_optin: this.profile.companyOptIn,
                    });
                }
            }
            else {
                this.anonymous = true;
            }
        }));
    }
    checkProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isCheckProfile) {
                return;
            }
            // 一度もプロフィール登録を促すモーダルを表示していない場合はチェック
            if (!this.profile.modalClosedAt) {
                this.showInvalidProfileModal = !(yield this.users.isValidProfile());
                return;
            }
            // 最後にモーダルを閉じた日時が一定期間経過している場合はチェック
            const modalClosedAt = this.profile.modalClosedAt.toDate().getTime();
            const now = new Date().getTime();
            const diffDay = Math.floor((now - modalClosedAt) / (1000 * 60 * 60 * 24));
            if (diffDay >= 7) {
                this.showInvalidProfileModal = !(yield this.users.isValidProfile());
            }
        });
    }
    onClickFav() {
        this.clickFav.emit(this.story);
    }
    back(event) {
        this.clickBack.emit(this.backUrl);
        return false;
    }
    signOut() {
        // KARTEタグ: ログアウト
        tracker.track('login', {
            status: false,
        });
        this.auth.auth.signOut();
        this.router.navigate(['.'], { relativeTo: this.route, queryParams: { v: 'logout' } });
    }
}
